var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article_detail"},[_c('div',{staticClass:"content",style:({minHeight:_vm.height+'px'})},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.articleData.content || '')}})]),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }